// extracted by css-extract-rspack-plugin
export default {"pageHeading":"_1ba7c1db","pageTitle":"_cd986113"};